module.exports = __webpack_public_path__ + "img/youtu-be.0f52b014.svg";